import React, { FC } from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { Typography } from '@material-ui/core';
import moment from 'moment';

import { CurrencyCode, currencyFormat } from 'utils/currencyFormat';
import { gray2, lighterGray, red } from 'utils/color-styles';

interface PayrollNoteProps {
  balance?: number;
  isUpcoming: boolean;
  nextPayrollDate: string;
  userDisplayCurrency: string;
}

export const PayrollNote: FC<PayrollNoteProps> = ({
  balance,
  isUpcoming,
  nextPayrollDate,
  userDisplayCurrency,
}) => {
  if (isUpcoming) {
    return (
      <Typography style={{ color: lighterGray, fontSize: 12 }}>
        Next payroll deduction payment to be paid on{' '}
        {moment(nextPayrollDate).format('MMM DD, YYYY')}
      </Typography>
    );
  }

  if (balance === 0) {
    return (
      <Typography style={{ color: gray2, fontSize: 12 }}>
        The payroll donations were paid in full
      </Typography>
    );
  }

  if (balance > 0) {
    return (
      <div style={{ display: 'flex', alignItems: 'flex-end' }}>
        <WarningIcon style={{ color: red, marginRight: 10 }} />
        <Typography style={{ color: red, fontSize: 12 }}>
          An additional +{currencyFormat(balance, userDisplayCurrency as CurrencyCode)} was deducted
          from this payroll schedule
        </Typography>
      </div>
    );
  }

  if (balance < 0) {
    return (
      <div style={{ display: 'flex', alignItems: 'flex-end' }}>
        <WarningIcon style={{ color: red, marginRight: 10 }} />
        <Typography style={{ color: red, fontSize: 12 }}>
          There is an outstanding balance of{' '}
          {currencyFormat(balance, userDisplayCurrency as CurrencyCode)} that wasn&apos;t paid
        </Typography>
      </div>
    );
  }

  return null;
};

export default PayrollNote;
